import { render, staticRenderFns } from "./HighlightContentsSection.vue?vue&type=template&id=95c97516&scoped=true"
import script from "./HighlightContentsSection.vue?vue&type=script&lang=ts"
export * from "./HighlightContentsSection.vue?vue&type=script&lang=ts"
import style0 from "./HighlightContentsSection.vue?vue&type=style&index=0&id=95c97516&prod&lang=scss&scoped=true"
import style1 from "./HighlightContentsSection.vue?vue&type=style&index=1&id=95c97516&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95c97516",
  null
  
)

export default component.exports